"use client";
import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { boxStyles, propsMappingToStyles } from './styles.js';
import { BoxPropsMapping } from './props.js';
import styled from 'styled-components';
import { styledContentText } from '../ContentText/styles.web.js';
import { generateBoxPropStyles } from './utils.js';
export { generateBoxPropStyleRow, getCssProperties, mapBoxPropValues } from './utils.js';
import { boxStyledOptions } from '../utils/helpers/styled.js';

var _excluded = ["boxRef", "hover", "as", "tag"];

// For example notification relies on this mechanism
var StyledBox = /*#__PURE__*/styled.div.withConfig(boxStyledOptions).withConfig({
  displayName: "Boxweb__StyledBox",
  componentId: "sc-1c6ag20-0"
})(["", "{color:", ";", " ", "}", ";&:hover{", "}"], styledContentText, function (p) {
  return p.textColor;
}, function (p) {
  return p.fontSize && generateBoxPropStyles('font-size', p.fontSize);
}, function (p) {
  return p.fontWeight && generateBoxPropStyles('font-weight', p.fontWeight);
}, boxStyles, function (p) {
  return p.$hover ? propsMappingToStyles(BoxPropsMapping)(p.$hover) : null;
});
var Box = function Box(_ref) {
  var boxRef = _ref.boxRef,
    hoverProp = _ref.hover,
    asProp = _ref.as,
    tag = _ref.tag,
    props = _objectWithoutProperties(_ref, _excluded);
  // istanbul ignore next
  if (asProp) {
    console.warn('as prop is being deprecated in favor of tag, they work in similar fashion so just swap to tag instead of as');
  }
  return /*#__PURE__*/React.createElement(StyledBox, _extends({
    "data-testid": "elemental-Box",
    ref: boxRef
    // support as prop for backwards compatibility
    ,
    as: asProp || tag,
    $hover: hoverProp
  }, props));
};

export { Box, StyledBox, generateBoxPropStyles };
